import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Img } from 'react-image';

const Image = styled(Img)`
  width: ${props => (props.theme.isPortrait ? 50 : 20)}vw;
`;

export default function Logo() {
  const { logo } = React.useContext(ThemeContext);

  return <Image src={logo} />;
}
